import authReducer from './reducers';

export { default as authOperations } from './operations';
export * from './types';

export default authReducer;
